import React, {useState} from 'react'
import Video from '../../video/bg.mp4'
import { HeroContainer, HeroBackground, VideoBackground, HeroContent, HeroP, HeroH1, HeroBtnWrapper, ArrowForward, ArrowRight } from './HeroElements'
import { Button } from '../ButtonElements'

const HeroSection = () => {
    const [hover, setHover] = useState(false)

    const onHover = () => {
        setHover(!hover)
    }

  return (
    <HeroContainer>
        <HeroBackground>
            <VideoBackground autoPlay loop muted src={Video} type='video/mp4' />

        </HeroBackground>
        <HeroContent>
            <HeroH1>Valgraen</HeroH1>
            <HeroP>Videoherní bůh, budoucí streamer #1 v Česku</HeroP>
            {/* <HeroBtnWrapper> */}
                {/* <Button to="signup" onMouseEnter={onHover} onMouseLeave={onHover} primary='true'>
                    Get Started {hover ? <ArrowForward /> : <ArrowRight />}
                </Button> */}

                {/* <Button to="about" onMouseEnter={onHover} onMouseLeave={onHover} primary='true' */}
                {/* smooth={true} duration={500} spy={true} exact='true' offset={-80}> */}
                    {/* Procházej {hover ? <ArrowForward /> : <ArrowRight />} */}
                {/* </Button> */}
            {/* </HeroBtnWrapper> */}
        </HeroContent>
    </HeroContainer>
  )
}

export default HeroSection